exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-l-1-js": () => import("./../../../src/pages/l1.js" /* webpackChunkName: "component---src-pages-l-1-js" */),
  "component---src-pages-l-2-js": () => import("./../../../src/pages/l2.js" /* webpackChunkName: "component---src-pages-l-2-js" */),
  "component---src-pages-l-3-js": () => import("./../../../src/pages/l3.js" /* webpackChunkName: "component---src-pages-l-3-js" */)
}

